import type { Account } from '@adtrackify/at-tracking-event-types';

import { useToggleSettingsStore } from '@/features/acquisition/stores/use-toggle-settings-store';
import { useCostConfigsStore } from '@/features/costs/stores/use-cost-configs-store';
import { useDashboardLayoutStore } from '@/features/dashboard/stores/dashboard-layout-store';
import { setDashboardStoreAccountId } from '@/features/dashboard/stores/use-unified-dashboard-store';
import { DEFAULT_TIMEZONE } from '@/lib/constants/timezone-constants';
import { setAccountTimezoneCache } from '@/store/account/timezone-cache';

// Runs before the new account is committed, so pages mounting under it never read
// the previous account's state and their first writes land in the right storage key.
export function resetAccountScopedStores(nextAccount: Account): void {
  // The dashboard store computes default date ranges from this cache.
  setAccountTimezoneCache(nextAccount.settings?.selectedTimezone ?? DEFAULT_TIMEZONE);

  useToggleSettingsStore.getState().reset();
  useCostConfigsStore.getState().invalidate();
  useDashboardLayoutStore.getState().resetLayoutState();
  setDashboardStoreAccountId(nextAccount.id);
}
